import { useEffect, useState } from 'react';

import 'cloudinary-video-player/cld-video-player.min.css';
import 'cloudinary-video-player/cld-video-player';

export type CloudinaryVideoPlayerEnrichedWindow = Window & {
  cloudinary: {
    videoPlayer: CloudinaryVideoPlayer;
  };
};

export type CloudinaryVideoPlayerOptions = {
  analytics?: { events: string[] };
  showLogo?: boolean;
  controls?: boolean;
  cloud_name?: any;
  fluid?: boolean;
  muted?: boolean;
  autoplay?: boolean;
  autoplayMode?: 'never' | 'always' | 'on-scroll';
  loop?: boolean;
  preload?: string;
  playsInline?: boolean;
  colors?: { text?: string; accent?: string; base?: string };
  posterOptions?: {
    publicId?: string;
  };
};

export type CloudinaryVideoPlayer = (elementSelector: string, options: CloudinaryVideoPlayerOptions) => any;

export const useCloudinaryWithVideoPlayer = () => {
  const [cloudinaryVideoPlayer, setCloudinaryVideoPlayer] = useState<
    { videoPlayer: CloudinaryVideoPlayer } | undefined
  >();
  const isClient = typeof window !== 'undefined';

  useEffect(() => {
    if (isClient && !cloudinaryVideoPlayer) {
      if (typeof (window as unknown as CloudinaryVideoPlayerEnrichedWindow)?.cloudinary?.videoPlayer !== 'undefined') {
        setCloudinaryVideoPlayer((window as unknown as CloudinaryVideoPlayerEnrichedWindow)?.cloudinary);
      }
    }
  }, [isClient, cloudinaryVideoPlayer]);

  return cloudinaryVideoPlayer;
};
